import { DenormalizedCustomizableQuestion } from '@packages/types'
import React, { ReactNode } from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import ArrowDown from 'icons/bold/52-Arrows-Diagrams/01-Arrows/arrow-down-1.svg'
import CommonDropdownQuestion from 'themes/common/components/questions/dropdown/DropdownQuestion'

import DropdownQuestionOption from './DropdownQuestionOption'

import './DropdownQuestion.scss'

interface DropdownQuestionProps {
  question: DenormalizedCustomizableQuestion
  lang?: string
  country?: string
  selectAnswer: (answerId: string) => void
  selectAnswers: (answerIds: string[]) => void
  className?: string
  requiredWarning?: boolean
  children?: ReactNode
  pricing: Record<string, string>
  currency: string
  answersOutOfStock: string[]
}

const DropdownQuestion = (props: DropdownQuestionProps) => {
  const style = useThemeSettings('textInputAndDropdown')
  const price = useThemeSettings('price')

  return (
    <div className="dropdown-question">
      <CommonDropdownQuestion
        {...props}
        textInputAndDropdownStyle={style}
        showExtraPrice={price.showExtraPrice}
        dropdownIcon={<ArrowDown className="arrow-down" style={{ fill: style.fieldFontColor }} />}
        customOptionsComponent={DropdownQuestionOption}
      />
    </div>
  )
}

export default DropdownQuestion
